import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1a6a48a2 = () => interopDefault(import('../../../pages/404.vue' /* webpackChunkName: "pages/404" */))
const _d7f72104 = () => interopDefault(import('../../../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _403d6f1a = () => interopDefault(import('../../../pages/datenschutz.vue' /* webpackChunkName: "pages/datenschutz" */))
const _5af5082e = () => interopDefault(import('../../../pages/impressum.vue' /* webpackChunkName: "pages/impressum" */))
const _646a3d6a = () => interopDefault(import('../../../pages/krisenintervention.vue' /* webpackChunkName: "pages/krisenintervention" */))
const _bfeeae20 = () => interopDefault(import('../../../pages/orte/index.vue' /* webpackChunkName: "pages/orte/index" */))
const _1cf23ae2 = () => interopDefault(import('../../../pages/shop.vue' /* webpackChunkName: "pages/shop" */))
const _0a81ee54 = () => interopDefault(import('../../../pages/teilnahmebedingungen.vue' /* webpackChunkName: "pages/teilnahmebedingungen" */))
const _46b9acf9 = () => interopDefault(import('../../../pages/veranstaltungen/index.vue' /* webpackChunkName: "pages/veranstaltungen/index" */))
const _1c7bf216 = () => interopDefault(import('../../../pages/anmeldung/token/index.vue' /* webpackChunkName: "pages/anmeldung/token/index" */))
const _d75420bc = () => interopDefault(import('../../../pages/orte/karlsminde.vue' /* webpackChunkName: "pages/orte/karlsminde" */))
const _4e21259c = () => interopDefault(import('../../../pages/anmeldung/mitarbeiter/_token.vue' /* webpackChunkName: "pages/anmeldung/mitarbeiter/_token" */))
const _67732132 = () => interopDefault(import('../../../pages/anmeldung/token/_token.vue' /* webpackChunkName: "pages/anmeldung/token/_token" */))
const _64443966 = () => interopDefault(import('../../../pages/blog/_id.vue' /* webpackChunkName: "pages/blog/_id" */))
const _3ae7b150 = () => interopDefault(import('../../../pages/orte/_id.vue' /* webpackChunkName: "pages/orte/_id" */))
const _0edeccbe = () => interopDefault(import('../../../pages/veranstaltungen/_id.vue' /* webpackChunkName: "pages/veranstaltungen/_id" */))
const _07224a32 = () => interopDefault(import('../../../pages/downloads/_.vue' /* webpackChunkName: "pages/downloads/_" */))
const _e18f3aee = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404",
    component: _1a6a48a2,
    name: "404"
  }, {
    path: "/blog",
    component: _d7f72104,
    name: "blog"
  }, {
    path: "/datenschutz",
    component: _403d6f1a,
    name: "datenschutz"
  }, {
    path: "/impressum",
    component: _5af5082e,
    name: "impressum"
  }, {
    path: "/krisenintervention",
    component: _646a3d6a,
    name: "krisenintervention"
  }, {
    path: "/orte",
    component: _bfeeae20,
    name: "orte"
  }, {
    path: "/shop",
    component: _1cf23ae2,
    name: "shop"
  }, {
    path: "/teilnahmebedingungen",
    component: _0a81ee54,
    name: "teilnahmebedingungen"
  }, {
    path: "/veranstaltungen",
    component: _46b9acf9,
    name: "veranstaltungen"
  }, {
    path: "/anmeldung/token",
    component: _1c7bf216,
    name: "anmeldung-token"
  }, {
    path: "/orte/karlsminde",
    component: _d75420bc,
    name: "orte-karlsminde"
  }, {
    path: "/anmeldung/mitarbeiter/:token?",
    component: _4e21259c,
    name: "anmeldung-mitarbeiter-token"
  }, {
    path: "/anmeldung/token/:token",
    component: _67732132,
    name: "anmeldung-token-token"
  }, {
    path: "/blog/:id",
    component: _64443966,
    name: "blog-id"
  }, {
    path: "/orte/:id",
    component: _3ae7b150,
    name: "orte-id"
  }, {
    path: "/veranstaltungen/:id",
    component: _0edeccbe,
    name: "veranstaltungen-id"
  }, {
    path: "/downloads/*",
    component: _07224a32,
    name: "downloads-all"
  }, {
    path: "/",
    component: _e18f3aee,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
